import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";

import { connect, useDispatch } from "react-redux";

import { addSearchKeywordToFilters } from "../../actions/variantFilterActions";
import { getAllVariantsWithFilters } from "../../actions/variantActions";

import MobileMainNav from "./partials/mobile-nav";
import axios from "axios";
const imageSrc = process.env.REACT_APP_API_URL + "/uploads/variant_images/";

function MobileMenu(props) {
  function hideMobileMenu() {
    if (document.querySelector("body").classList.remove("mmenu-active"))
      document.querySelector("body").classList.remove("mmenu-active");
  }

  function hideSideBar() {
    if (
      document.querySelector("body").classList.contains("sidebar-filter-active")
    )
      document.querySelector("body").classList.remove("sidebar-filter-active");
  }

  let categories = props.categories;
  const dispatch = useDispatch();
  const [keysearch, setKeysearch] = useState();

  return (
    <div className="mobile-menu-container">
      <div className="mobile-menu-wrapper">
        <span className="mobile-menu-close">
          <i className="icon-close"></i>
        </span>

        {/* <form action="#" method="get" className="mobile-search">
          <label htmlFor="mobile-search" className="sr-only">
            Search
          </label>
          <input
            type="search"
            className="form-control"
            name="mobile-search"
            id="mobile-search"
            placeholder="Cherchez nos produits ..."
            onChange={(e) => setKeysearch(e.target.value)}
            required
          />
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              dispatch(addSearchKeywordToFilters(keysearch));
              dispatch(getAllVariantsWithFilters());
              
            }}
          >
            <i className="icon-search"></i>
          </button>
        </form> */}

        <Tabs defaultIndex={0} selectedTabClassName="show">
          <TabList
            className="nav nav-pills-mobile nav-border-anim"
            role="tablist"
          >
            <Tab className="nav-item">
              <span className="nav-link">Menu</span>
            </Tab>

            <Tab className="nav-item">
              <span className="nav-link">Catégories</span>
            </Tab>
          </TabList>

          <div className="tab-content">
            <TabPanel>
              <MobileMainNav />
            </TabPanel>

            <TabPanel>
              <nav className="mobile-cats-nav">
                <ul className="mobile-cats-menu">
                  {categories.map((item) => (
                    <li key={item.id} className="megamenu-container">
                      <Link
                        to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${item.slug}`}
                        onClick={hideMobileMenu}
                      >
                        <i className="" key={`${item.id}`}></i>
                        {item.nameFr}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </TabPanel>
          </div>
        </Tabs>

        <div className="social-icons">
          <Link to="#" className="social-icon" target="_blank" title="Facebook">
            <i className="icon-facebook-f"></i>
          </Link>
          <Link to="#" className="social-icon" target="_blank" title="Twitter">
            <i className="icon-twitter"></i>
          </Link>
          <Link
            to="#"
            className="social-icon"
            target="_blank"
            title="Instagram"
          >
            <i className="icon-instagram"></i>
          </Link>
          <Link to="#" className="social-icon" target="_blank" title="Youtube">
            <i className="icon-youtube"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    categories: state.categories.categories ? state.categories.categories : [],
  };
}

export default connect(mapStateToProps, {
  addSearchKeywordToFilters,
  getAllVariantsWithFilters,
})(MobileMenu);
